<app-dynamic-form
  [btnLabel]="'DATA.COMMON.ACTIONS.SAVE' | translate"
  [submit]="true"
  [reset]="false"
  (formData)="send($event)"
  [formCols]="12"
  [formFields]="currencyInput">
</app-dynamic-form>
